<template>
  <div>
    <jd-dialog
      class="select-task-group"
      :title="title"
      :visible.sync="dialogVisible"
      append-to-body
      width="1200px"
      :sureLoading="sureLoading"
      :sureDisable="currentStep == 1 && !canvasTableData.length"
      @close="handleClose"
      @comfirm="handleConfirm"
    >
      <div class="select-group-content">
        <div class="select-group-steps">
          <div
            class="select-group-step"
            :class="{ 'select-group-step--active': currentStep === 0 }"
          >
            <img
              :src="
                cdnUrl +
                (currentStep === 0
                  ? 'ai-icon-person-active.svg'
                  : 'ai-icon-person.svg')
              "
              alt="人群"
            />
            <span class="select-group-step__title">第一步 创建人群</span>
          </div>
          <div class="select-group-step-icon">
            <img :src="cdnUrl + 'ai-icon-select-right.svg'" alt="线" />
          </div>
          <div
            class="select-group-step"
            :class="{ 'select-group-step--active': currentStep === 1 }"
          >
            <img
              :src="
                cdnUrl +
                (currentStep === 1
                  ? 'ai-icon-canvas-active.svg'
                  : 'ai-icon-canvas.svg')
              "
              alt="画布"
            />
            <span class="select-group-step__title">第二步 创建营销画布</span>
          </div>
        </div>
        <!-- 第一步：选择人群 -->
        <div v-if="currentStep === 0">
          <div class="select-group-header" v-if="!showLoading">
            <div class="select-group-tip">
              <span>选择本次需要生成的人群方案</span>
            </div>
            <div class="select-group-count">
              <span>已勾选</span>
              <span class="select-group-count__active">{{
                selectedCount
              }}</span>
              <span>条</span>
            </div>
          </div>
          <div class="select-group-table-wrapper">
            <div v-if="showLoading" class="select-group-loading">
              <img :src="cdnUrl + 'ai-icon-loading-box.png'" alt="loading" />
              <span class="select-group-loading-text">创建人群任务执行中...</span>
            </div>
            <jd-table
              :showPage="false"
              :selection="!showLoading"
              rowKey="crowdNo"
              :tableInfo="tableInfo"
              :tableData="tableData"
              :maxHeight="maxHeight"
              :loading="!showLoading && loading"
              @selection-change="handleSelectionChange"
            >
              <template #tagCombination="{ row }">
                <div class="text-wrap">{{ row.tagCombination }}</div>
              </template>
            </jd-table>
          </div>
        </div>
        <!-- 第二步：营销画布 -->
        <div v-else-if="currentStep === 1">
          <div class="canvas-header">
            <span class="canvas-tip"
              >以下内容可在执行完营销任务后在画布中修改</span
            >
          </div>
          <div class="canvas-table-wrapper">
            <jd-table
              :showPage="false"
              :selection="false"
              :tableInfo="canvasTableInfo"
              :tableData="canvasTableData"
              :maxHeight="maxHeight"
              :loading="canvasLoading"
            >
            </jd-table>
          </div>
        </div>
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getCrowdJsonMarketing,
  confirmCrowdMarketing,
  getCanvasPreview,
  getStrategyStyle,
} from "@/api/ai/newAi";
export default {
  name: "SelectGroup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    build: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      currentStep: 0,
      maxHeight: "520",
      loading: false,
      pollingTimer: null,
      canvasLoading: false,
      tableData: [],
      selectedRows: [],
      tableInfo: [
        { prop: "crowdNo", label: "人群编号", width: "100" },
        { prop: "crowdName", label: "人群名称", minWidth: "160" },
        {
          prop: "tagCombination",
          label: "标签组合",
          minWidth: "240",
          slot: "tagCombination",
        },
        { prop: "crowdFeature", label: "人群特征", minWidth: "200" },
        { prop: "coreGoal", label: "核心目标", width: "120" },
      ],
      canvasTableInfo: [
        { prop: "crowdName", label: "人群名称", minWidth: "180" },
        {
          prop: "smsContent",
          label: "短信文案",
          minWidth: "500",
        },
        { prop: "sendTime", label: "发送时间", width: "180" },
      ],
      canvasTableData: [],
      sureLoading: false,
      buildLoading: false,
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),
    title() {
      return "创建任务";
    },
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedCount() {
      return this.selectedRows.length;
    },
    showLoading() {
      return this.build || this.buildLoading;
    },
  },
  watch: {
    build(newStatus, oldStatus) {
      if (oldStatus && !newStatus) {
        this.currentStep = 1;
        this.getCanvasPreviewFn();
      }
    },
  },
  created() {
    this.getLoading();
    this.getCrowdJsonFn();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    getLoading() {
      getStrategyStyle({ strategyMessageId: this.item.id }).then((res) => {
        if (res.code == 200) {
          if (res.data == "task_crowd_creating") {
            this.buildLoading = true;
            this.startPolling();
          } else if (res.data == "task_canvas_preview") {
            this.currentStep = 1;
            this.getCanvasPreviewFn();
          } else {
            this.buildLoading = false;
          }
        }
      });
    },
    startPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
      }
      this.pollingTimer = setInterval(() => {
        getStrategyStyle({ strategyMessageId: this.item.id })
          .then((res) => {
            if (res.code == 200) {
              if (res.data != "task_crowd_creating") {
                this.stopPolling();
                this.buildLoading = false;
                if (res.data == "task_canvas_preview") {
                  this.currentStep = 1;
                  this.getCanvasPreviewFn();
                }
              }
            } else {
              this.stopPolling();
              this.buildLoading = false;
            }
          })
          .catch(() => {
            this.stopPolling();
            this.buildLoading = false;
          });
      }, 3000);
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    getCrowdJsonFn() {
      this.loading = true;
      getCrowdJsonMarketing({
        platform: "JD",
        userId: this.loginUserInfo.platformAccountInfo.platformCompanyUserId,
        messageId: this.item.id,
      })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.tableData = res.data || [];
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    getCanvasPreviewFn() {
      this.canvasLoading = true;
      getCanvasPreview({
        strategyMessageId: this.item.id,
      })
        .then((res) => {
          this.canvasLoading = false;
          if (res.code == 200) {
            const data = res.data;
            if (data.crowds && data.crowds.length > 0) {
              this.canvasTableData = data.crowds;
            }
          }
        })
        .catch(() => {
          this.canvasLoading = false;
        });
    },
    handleConfirm() {
      if (this.currentStep == 0) {
        if (!this.selectedRows.length) {
          this.$message.warning("人群方案不可为空，请选择人群方案");
          return;
        }
        this.sureLoading = true;
        confirmCrowdMarketing({
          platform: "JD",
          userId: this.loginUserInfo.platformAccountInfo.platformCompanyUserId,
          sellerId: this.loginUserInfo.venderId || "",
          messageId: this.item.id,
          selectedCrowdNos: this.selectedRows.map((item) => item.crowdNo),
        })
          .then((res) => {
            this.sureLoading = false;
            if (res.code == 200) {
              this.$emit("comfirm", res.data);
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.sureLoading = false;
          });
      } else if (this.currentStep == 1) {
        this.$emit("createCanvas");
      }
    },
    handleClose() {
      this.selectedRows = [];
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.select-task-group {
  .el-dialog__body {
    padding: 0 !important;
    height: 699px;
  }
}
</style>

<style lang="scss" scoped>
.active {
  color: #ff304f;
}
.text-wrap {
  white-space: pre-wrap;
}
.dialog-title {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}
.dialog-sub {
  font-size: 12px;
  color: #999999;
  margin-left: 16px;
}
.select-group-content {
  width: 100%;
}
.select-group-header {
  padding: 0px 24px;
  display: flex;
  justify-content: space-between;
}
.select-group-tip {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}
.select-group-count {
  font-size: 14px;
  color: #333;
  &__active {
    color: #3159ff;
    margin: 0px 4px;
  }
}
.select-group-table-wrapper {
  width: 100%;
  padding: 20px 24px 30px;
  position: relative;
}
.select-group-loading {
  position: absolute;
  top: 20px;
  left: 24px;
  right: 24px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
  height: 552px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
  &-text {
    color: #3159ff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 8px;
  }
}
.select-group-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ededed;
  margin-bottom: 20px;
  padding: 20px 0px;
}
.select-group-step {
  display: flex;
  align-items: center;
  img {
    width: 22px;
    height: 22px;
    margin-right: 4px;
  }
  &__title {
    font-size: 16px;
    color: #999;
  }
  &--active {
    .select-group-step__title {
      color: #333;
      font-weight: 500;
    }
  }
}
.select-group-step-icon {
  margin: 0px 100px;
  img {
    width: 22px;
    height: 22px;
  }
}
.canvas-header {
  padding: 0px 24px;
}
.canvas-tip {
  font-size: 14px;
  color: #666;
}
.canvas-table-wrapper {
  padding: 20px 24px 30px;
}
</style>
